export const enUsers = {
  title: "Users",
  subtitle: "View all users in your organization.",
  empty: "No users found.",
  actions: {
    newUser: "New User",
  },
  newUserModal: {
    title: "New User",
    closeAria: "Close dialog",
    fields: {
      email: "Email",
      fullName: "Full name",
    },
    validation: {
      required: "This field is required.",
      invalidEmail: "Enter a valid email address.",
    },
    actions: {
      cancel: "Cancel",
      addUser: "Add User",
    },
    errors: {
      saveFailed: "Failed to add user. Please try again.",
    },
  },
  table: {
    email: "Email",
    fullName: "Full name",
    actions: "Actions",
    ariaLabel: "Users",
  },
  missingFullName: "—",
  tenantRoles: {
    heading: "Workspace roles",
    subheading: "Roles {{email}} holds across the whole workspace.",
    closeAria: "Close dialog",
    held: "Currently held",
    none: "No workspace roles.",
    addLabel: "Add a role",
    addHelp:
      "Workspace roles grant settings access. Any domain permission they carry applies to " +
      "every domain.",
    noneAvailable: "No workspace roles left to add. Create one on the Roles page.",
    assign: "Assign",
    close: "Close",
    manageAria: "Manage workspace roles for {{email}}",
    revokeAria: "Remove {{role}}",
    columnHeader: "Workspace roles",
    errors: {
      assignFailed: "Failed to assign the role. Please try again.",
      revokeFailed: "Failed to remove the role. Please try again.",
    },
  },
  adminAccess: {
    grantAria: "Make {{email}} a Super Administrator",
    revokeAria: "Remove Super Administrator from {{email}}",
    grantDialog: {
      heading: "Make this user a Super Administrator?",
      subheading:
        "They will be able to manage users, roles and every setting — including making other " +
        "users Super Administrators.",
      cancel: "Cancel",
      confirm: "Grant Role",
    },
    revokeDialog: {
      heading: "Remove Super Administrator?",
      subheading:
        "This user will immediately lose every permission the role grants.",
      cancel: "Cancel",
      confirm: "Remove Role",
    },
    errors: {
      grantFailed: "Failed to grant the role. Please try again.",
      revokeFailed: "Failed to remove the role. Please try again.",
    },
  },
  deleteDialog: {
    heading: "Are you sure you want to delete this user?",
    subheading:
      "Deleting this user will revoke all their permissions and access immediately.",
    cancel: "Cancel",
    confirm: "Delete",
    deleteAria: "Delete user {{email}}",
    errors: {
      deleteFailed: "Failed to delete user. Please try again.",
    },
  },
  profile: {
    title: "My Profile",
    subtitle: "View and update your account details.",
    fields: {
      fullName: "Full name",
      email: "Email",
    },
    validation: {
      nameRequired: "Full name is required.",
    },
    password: {
      title: "Password",
      description: "Choose a new password. You'll stay signed in on this device.",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      changeButton: "Update password",
      changeSucceeded: "Password updated successfully.",
      validation: {
        currentRequired: "Enter your current password.",
        newRequired: "Enter a new password.",
        confirmMismatch: "Passwords do not match.",
      },
      errors: {
        invalidCurrentPassword: "That current password is incorrect.",
        weakNewPassword:
          "That password does not meet the requirements: at least 12 characters, with upper and lower case letters, a number, and a symbol.",
        mfaRequired:
          "Your account uses two-factor authentication, which this form does not support yet. Please contact support to change your password.",
        tooManyAttempts: "Too many attempts. Please wait a few minutes and try again.",
        unknown: "Could not change your password. Please try again.",
      },
    },
    actions: {
      saveSucceeded: "Profile updated successfully.",
    },
    errors: {
      saveFailed: "Failed to update profile. Please try again.",
    },
  },
  cache: {
    clearButton: "Clear my cache",
    clearUserAria: "Clear cached data for {{email}}",
    confirm: {
      title: "Clear cached data?",
      ownBody:
        "Your cached responses will be removed and rebuilt the next time you open each page.",
      userBody:
        "Cached responses for {{email}} will be removed and rebuilt the next time they open each page.",
      cancel: "Cancel",
      confirmLabel: "Clear cache",
    },
    ownCleared: "Your cached data was cleared.",
    userCleared: "Cached data cleared for that user.",
    errors: {
      clearFailed: "Failed to clear cached data. Please try again.",
    },
  },
} as const;
